import { InfoList as AntdInfoList } from "@empglabs/backoffice-ui-kit"

const InfoList = props => {
  return <AntdInfoList {...props} />
}

export default InfoList
